import { createSelector, MemoizedSelector } from '@ngrx/store';
import { Rider } from '@app/rest-client/faxe/models/rider';
import { getRiderState } from '@app/store/faxe/faxe-selectors';
import { selectAllRider } from '@app/store/faxe/rider/rider.reducer';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';
import { defined } from '@app/fremework/functions';


export const selectRiderAll: MemoizedSelector<object, Rider[]> = createSelector(
  getRiderState,
  selectAllRider
);

export const selectRidersState =
  ():
    MemoizedSelector<object, { riders: Rider[], sliceState: SliceState }> =>
    createSelector(
      getRiderState,
      selectRiderAll,
      (state, all) => ({
        riders: all,
        sliceState: state?.meta?.sliceState
      })
    );

export const selectRiderByRaceGuid =
  (raceGuid: string, sliceState: SliceState):
    MemoizedSelector<object, Rider[]> =>
    createSelector(
      getRiderState,
      selectRiderAll,
      (state, all) =>
        all
          .filter(rider => (defined(state?.meta?.sliceState) &&
              (state.meta.sliceState === SliceState.total || sliceState === SliceState.reportable))
            && rider.raceGuid === raceGuid)
    );

